import React from "react";
import logo from '../assets/images/logo/solar-logo.png' 

function MainLoader (){
    return(
        <div className="loader-container">
        <img src={logo} alt="Logo" className="loader-logo" />
      </div>
    )
}

export default MainLoader;